import apiFetch from '@wordpress/api-fetch'
import { addQueryArgs } from '@wordpress/url'

const sortNews = () => {
    const sort = () => {
        document.querySelectorAll('.news-thread').forEach(thread => {
            const columnCount = getComputedStyle(thread).gridTemplateColumns.split(' ').length
            const lastColumnCount = thread.getAttribute('data-columns')

            if (lastColumnCount && parseInt(lastColumnCount) === parseInt(columnCount)) {
                return
            }

            if (thread.classList.contains('initialized')) {
                thread.classList.remove('initialized')
            }

            thread.setAttribute('data-columns', columnCount)

            const items = Array.from(thread.querySelectorAll('.news-item')).reduce((res, item) => {
                res[item.getAttribute('data-offset')] = item
                return res
            }, [])

            const amount = items.length

            const tmp = document.createElement('div')

            if (columnCount === 1) {
                const column = document.createElement('div')
                column.classList.add('news-column')

                for (let i = 0; i < amount; i++) {
                    column.appendChild(items[i])
                }

                tmp.appendChild(column)
            } else {
                const column1 = document.createElement('div')
                column1.classList.add('news-column')

                const column2 = document.createElement('div')
                column2.classList.add('news-column')

                let left = true
                for (let i = 0; i < amount; i++) {
                    if (left) {
                        column1.appendChild(items[i])
                    } else {
                        column2.appendChild(items[i])
                    }
                    left = !left
                }

                tmp.appendChild(column1)
                tmp.appendChild(column2)
            }

            thread.innerHTML = tmp.innerHTML

            const loadMoreButton = thread.parentNode.querySelector('button.load-more')
            if (loadMoreButton && !loadMoreButton.classList.contains('initialized')) {
                loadMoreButton.addEventListener('click', () => {
                    const archiveLink = thread.getAttribute('data-archive-link')
                    loadMoreButton.classList.add('loading')

                    const query = {}
                    if (archiveLink) {
                        query['archiveLink'] = archiveLink
                    }

                    apiFetch({ path: addQueryArgs(`/apothekehart/v1/news/${amount + 2}`, query) })
                        .then(res => {
                            thread.parentNode.innerHTML = res
                            sort()
                            loadMoreButton.classList.remove('loading')
                        })
                })
                loadMoreButton.classList.add('initialized')
            }

            thread.classList.add('initialized')
        })
    }

    sort()
    window.addEventListener('resize', sort)
}

export { sortNews }